import { useTranslation } from '@web_opxp/features';

interface ISubscriptionLabelProps {
  labelLocaId: string;
  value: string;
}

export default function SubscriptionLabel({ labelLocaId, value }: Readonly<ISubscriptionLabelProps>) {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div className="col-3 col-m-2">
        <p className="label">{t(labelLocaId)}</p>
      </div>
      <div className="col-9 col-m-2">
        <p>{value}</p>
      </div>
    </div>
  );
}
